export const GET_STUDENT_BY_ID = 'student/GET_STUDENT_BY_ID';
export const GRANT_STUDENT_COURSES_ACCESS =
  'student/GRANT_STUDENT_COURSES_ACCESS';
export const UPDATE_STUDENT_BY_ID = 'student/UPDATE_STUDENT_BY_ID';
export const ISSUE_STUDENT_CERTIFICATE = 'student/ISSUE_STUDENT_CERTIFICATE';
